var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bfheader'),_c('userGroupHeader'),_c('div',{staticClass:"main-content mt-2"},[_c('router-view')],1),_c('bffooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }